// Where a campaign is on its own clock.
//
// Its own module because three features now need it — the battlemap footer,
// the adventure's live-progress panel, and anything else that has to compare
// work done against time spent. It lived in the battlemap's layout, which
// meant the adventures page importing a module about battlefield geometry to
// get four lines of date arithmetic.

/**
 * Sprint elapsed fraction from the window, clamped to [0,1].
 *
 * A degenerate window — unparseable dates, or an end before its start —
 * returns 0 rather than NaN. A NaN would propagate into a CSS width and
 * render as a bar of no width with no error, which is the kind of failure
 * that gets noticed a week later.
 */
export function elapsedFraction(startsAt: string, endsAt: string, now = Date.now()): number {
  const s = new Date(startsAt).getTime();
  const e = new Date(endsAt).getTime();
  if (!Number.isFinite(s) || !Number.isFinite(e) || e <= s) return 0;
  return Math.max(0, Math.min(1, (now - s) / (e - s)));
}
